/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mUpgradeItem.vue?vue&type=template&id=ed634206&scoped=true"
import script from "./mUpgradeItem.vue?vue&type=script&lang=js"
export * from "./mUpgradeItem.vue?vue&type=script&lang=js"
import style0 from "./mUpgradeItem.vue?vue&type=style&index=0&id=ed634206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed634206",
  null
  
)

export default component.exports